import styled from "styled-components";
import tw from "twin.macro";

import { BoxSizingStyle } from "../BoxSizingStyle";
import { FontStyle } from "../FontStyle";
import { List } from "../List";

export const StyledNavElement = styled.nav`
  ${tw`tw-w-full`}
  ${tw`tw-overflow-hidden`}
  ${FontStyle}
  ${BoxSizingStyle}
`;

StyledNavElement.displayName = "StyledNavElement";

export const StyledListWrapper = styled.div`
  ${tw`tw-inline-block`}
`;

StyledListWrapper.displayName = "StyledListWrapper";

export const StyledOList = styled.ol`
  ${tw`tw-flex`}
  ${tw`tw-items-start`}
  ${tw`tw-items-center`}
  ${tw`tw-list-none`}
  ${tw`tw-p-0`}
  ${tw`tw-m-0`}
`;

StyledOList.displayName = "StyledOList";

export const StyledMenuList = styled(List)`
  ${tw`tw-py-2`}
`;

StyledMenuList.displayName = "StyledMenuList";

export const StyledBreadcrumbListItem = styled.li`
  ${tw`tw-flex`}
  ${tw`tw-flex-shrink-0`}
`;

StyledBreadcrumbListItem.displayName = "StyledBreadcrumbListItem";
